import { BroadbandCartAddonCard } from "@features/cart/components/BroadbandCard/BroadbandCartAddon/BroadbandCartAddonComponent/BroadbandCartAddonCard";
import { useBroadbandCartAddon } from "@features/cart/components/BroadbandCard/BroadbandCartAddon/useBroadbandCartAddon";
import { ICart, ICartAddon } from "@features/cart/ICart";
import { AddWifiBoost } from "../../AddNew/AddWifiBoost";
import { Box } from "@mui/material";

interface IParams {
    cartAddonList: ICartAddon[];
    offerId: number;
    setCart(cart: ICart | undefined): void;
}

export const BroadbandCartAddon = (props: IParams) => {
    const { cartAddonList, offerId, setCart } = props;

    const hasAddonsInCart = cartAddonList.length > 0;

    const { wifiMeshOfferAddon, addAddon, removeAddon, clearAddons, counter, isLoading } = useBroadbandCartAddon({
        cartAddonList,
        offerId,
        setCart,
    });

    return (
        <Box mt={hasAddonsInCart ? 5 : 2}>
            {hasAddonsInCart && wifiMeshOfferAddon && (
                <BroadbandCartAddonCard
                    counter={counter}
                    description={wifiMeshOfferAddon.description}
                    handleAddAddon={addAddon}
                    handleClearAddons={clearAddons}
                    handleRemoveAddon={removeAddon}
                    isLoading={isLoading}
                    maxQuantity={wifiMeshOfferAddon.maxQuantity}
                />
            )}
            {!hasAddonsInCart && wifiMeshOfferAddon && <AddWifiBoost isLoading={isLoading} onClick={addAddon} />}
        </Box>
    );
};
